/**
 * 帳單頁面
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { Pay } from '@gov-mo/mpaas-js-bridge';
import { isMobile } from '@/utils';
import styles from './PaymentInformation.less';
import WebPaymentInformation from './WebPaymentInformation';

interface PaymentInformationProps {
  onSuccess?: (e: unknown) => void;
  onCancel?: (e: unknown) => void;
}

const mockTotal = 100;
const mockData = [{ name: 'Demo事项', price: 100, quantity: 1 }];

function PaymentInformation({ onSuccess, onCancel }: PaymentInformationProps) {
  const intl = useIntl();

  // APP监听支付结果返回
  Pay.listenPayResult((e) => {
    onSuccess?.(e);
  });
  // APP监听是否取消了支付
  Pay.listenPayLater((e) => {
    onCancel?.(e);
  });

  // PC端渲染
  if (!isMobile()) {
    return <WebPaymentInformation data={mockData} total={mockTotal} unit="MOP" />;
  }

  // 移動端渲染
  return (
    <div className={styles.root}>
      <div className={styles.nameArea}>
        <span className={styles.paymentName}>{intl.formatMessage({ id: 'Demo事项' })}</span>
      </div>

      {mockData.map((item) => {
        const { name, price, quantity } = item;
        return (
          <div key={name} className={styles.paymentArea}>
            <div className={styles.itemArea}>
              <span className={styles.itemName}>{`${intl.formatMessage({ id: '单价' })}`}</span>
              <span className={styles.itemValue}>
                <span className={styles.priceUnit}>MOP &nbsp;</span>
                <span className={styles.priceValue}>{price.toFixed(2)}</span>
              </span>
            </div>
            <div className={styles.itemArea}>
              <span className={styles.itemName}>{`${intl.formatMessage({ id: '数量' })}`}</span>
              <span className={styles.itemValue}>{quantity}</span>
            </div>
          </div>
        );
      })}

      <div className={styles.totalContainer}>
        <div className={styles.totalArea}>
          <span>{`${intl.formatMessage({ id: '合计' })}`}</span>
          <span className={styles.total}>
            <span className={styles.totalUnit}>MOP &nbsp;</span>
            <span className={styles.totalValue}>{mockTotal.toFixed(2)}</span>
          </span>
        </div>
      </div>
    </div>
  );
}

const EMPTY_FUNCTION = () => undefined;

PaymentInformation.defaultProps = {
  onSuccess: EMPTY_FUNCTION,
  onCancel: EMPTY_FUNCTION,
};

export default PaymentInformation;
